/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppointmentResponse } from '../../models/appointment-response';

export interface GetApiPublicGetAppointment$Params {

/**
 * The appointment uuid
 */
  uuid: string;
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicGetAppointment(http: HttpClient, rootUrl: string, params: GetApiPublicGetAppointment$Params, context?: HttpContext): Observable<StrictHttpResponse<AppointmentResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicGetAppointment.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppointmentResponse>;
    })
  );
}

getApiPublicGetAppointment.PATH = '/api/public/{_locale}/appointments/{uuid}';
